document.addEventListener('DOMContentLoaded', () => {
  const sizeSelect = document.querySelector('[data-size-select]');
  const variantInput = document.querySelector('[data-variant-input]');

  if (sizeSelect && variantInput) {
    sizeSelect.addEventListener('change', () => {
      variantInput.value = sizeSelect.value;
    });
  }

  const placeholderLinks = document.querySelectorAll('[data-placeholder-link]');
  if (placeholderLinks.length) {
    let toast = document.querySelector('[data-placeholder-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'placeholder-toast';
      toast.setAttribute('data-placeholder-toast', '');
      toast.setAttribute('role', 'status');
      toast.hidden = true;
      document.body.appendChild(toast);
    }
    placeholderLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        toast.hidden = false;
        toast.textContent =
          'Reserved, awaiting affiliate approval (' +
          (link.getAttribute('href') || '') +
          '). Not a live product URL.';
      });
    });
  }
});
